//#region Libraries
import styled from "styled-components";
//#endregion

export const Footer = styled.footer`
    background-color: var(--light-1);
    display: flex;
    justify-content: flex-end;
    padding: 15px 30px;
`;